import { render, staticRenderFns } from "./twoEnIndex.vue?vue&type=template&id=3bdf70df&scoped=true"
import script from "./twoEnIndex.vue?vue&type=script&lang=js"
export * from "./twoEnIndex.vue?vue&type=script&lang=js"
import style0 from "./twoEnIndex.vue?vue&type=style&index=0&id=3bdf70df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf70df",
  null
  
)

export default component.exports